import { TWITTER_BASE_URL_AUTH } from './../util/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TWITTER_BASE_URL, TWITTER_BASE_PARAMS } from '../util/constants';
import { Platform } from '@ionic/angular';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';

export class TwitterToken {
  // tslint:disable-next-line:variable-name
  access_token?: string;
  data: any;
}
export class Tweet {
  constructor(public id: string, public hora: string, public img_campanha: string, public data: string, public texto: string,
     public expanded_url: string) { }
}

@Injectable({
  providedIn: 'root'
})
export class TwitterService {
  private secret = btoa('cUMele8GTsTpunOIYSA2ckthg:kcG7RuVgYFLpeJCk2DG2rwPrreOY7dWkCsmqzk2zIHGHqU10RF');
  private bearer = '';
  next = '';
  limit = 20;

  $userData: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(private platfom: Platform, private http: HttpClient, private base: RequestService) {
  }

  async auth() {
    const opts = {
      Authorization: `Basic ${this.secret}`,
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    };
    let params: any = {'grant_type' : 'client_credentials'};
    if (!this.platfom.is('cordova')) {
      params = 'grant_type=client_credentials';
    }
    const result: TwitterToken = await this.base.post(TWITTER_BASE_URL_AUTH, params,
    opts);
    this.bearer = result.data.access_token;
  }

  async getDataTwitter(limit: number, last?: Tweet) {
    const opts = {
      Authorization: `Bearer ${this.bearer}`,
    };
    if (last) {
      this.next = `max_id=${last.id}`;
    }
    return this.base.get(`${TWITTER_BASE_URL}?&${this.next}&count=${this.limit}&${TWITTER_BASE_PARAMS}`, {},
     opts);
  }

  async getTweets(limit: number, last?: Tweet) {
    const tweets = [];
    await this.auth();
    const data:any = await this.getDataTwitter(limit, last);
    for (const status of data.data) {
      if (status.retweeted_status || status.in_reply_to_user_id || status.in_reply_to_status_id) {
        continue;
      }
      let medias = '';
      if (status.entities.media) {
        medias = status.entities.media[0].media_url;
      }
      let expanded_url = '';
      if (status.entities.media) {
        expanded_url = status.entities.media[0].expanded_url;
      } else {
        expanded_url = 'https://twitter.com/minsaude';
      }
      const date = new Date(status.created_at);
      const dateFormat = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
      const hourFormat = `${date.getHours()}:${date.getMinutes()}`;
      const tweet = new Tweet(status.id, hourFormat, medias, dateFormat, status.full_text, expanded_url);
      tweets.push(tweet);
    }
    return tweets;
  }

  protected headers(headers) {
    return {
      headers: new HttpHeaders(headers)
    };
  }

}
